<template>
    <div class="customer-view">
        <b-modal hide-footer v-model="isCustomerVisible" no-close-on-backdrop size="sm" class="pt-8" centered
            header-class="p-0" @cancel="$emit('setNewCustomerForm')"
            footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap" body-class="p-0">
            <template #modal-header>
                <div class="title-block text-center p-2">
                    {{ $translate('create_customer') }}
                    <button id="set-new-customer-form-btn" class="close" @click="$emit('setNewCustomerForm')">
                        x
                    </button>
                </div>
            </template>
            <template #default>
                <b-card>
                    <b-tabs v-model="tabIndex" card align="center">
                        <b-tab :title="$translate('general')" active class="p-0">
                            <b-card-body class="p-0 py-3">
                                <b-form @submit.stop.prevent="saveCustomer()">
                                    <b-row>
                                        <b-col md="6" cols="12">
                                            <label class="mb-3"><strong>{{
            $translate('code')
        }}</strong>
                                            </label>
                                            <b-input id="code" name="code" v-model="model.code" type="text"></b-input>
                                        </b-col>
                                        <b-col md="6" cols="12" class="mt-3 mt-md-0">
                                            <label class="mb-3"><strong>{{ $translate('name')
                                                    }}<span v-custom-validation="$textRequired()
            " class="red">*</span></strong></label>
                                            <b-input id="input-name" v-model="model.name" required
                                                :error="errors.first('name')" type="text"></b-input>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="6" cols="12" class="mt-3">
                                            <label class="mb-3"><strong>{{
            $translate('email_address')
        }}</strong></label>
                                            <b-input name="email" id="email" v-model="model.email" type="email"></b-input>
                                        </b-col>
                                        <b-col md="6" cols="12" class="mt-3">
                                            <label class="mb-3"><strong>{{
            $translate('telephone')
        }}</strong></label>
                                            <b-input id="phone" name="phone" v-model="model.phone" type="tel"></b-input>
                                        </b-col>
                                        <b-col md="6" cols="12" class="mt-3">
                                            <label class="mb-3"><strong>{{
            $translate('work_number')
        }}</strong></label>
                                            <b-input id="work_number" name="work_number"
                                                v-model="model.work_number"></b-input>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="6" cols="12" class="mt-3" v-if="checkCustomerAdditionaField1">
                                            <label class="mb-3"><strong>{{
            customer_additional_field_1.label
        }}</strong></label>
                                            <b-input id="customer-additional-field-1" name="customer-additional-field-1"
                                                v-model="model.additional_field_1
            " type="text"></b-input>
                                        </b-col>
                                        <b-col md="6" cols="12" class="mt-3" v-if="checkCustomerAdditionaField2">
                                            <label class="mb-3"><strong>{{
            customer_additional_field_2.label
        }}</strong></label>
                                            <b-input id="customer-additional-field-2" name="customer-additional-field-2"
                                                v-model="model.additional_field_2
            " type="text"></b-input>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col md="6" cols="12" class="mt-3" dd>
                                            <label class="mb-3"><strong>{{
            $translate(
                'customer_segment'
            )
        }}</strong></label>
                                            <b-form-select class="form-control" id="input-customer-segment" v-model="model.customer_segment_id
            " value-field="id" text-field="name" :options="customerSegments">
                                                <template #first>
                                                    <b-form-select-option :value="null">
                                                        {{
            $translate(
                'select_customer_segment'
            )
        }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                        <b-col md="6" cols="12" class="mt-3 dd">
                                            <label class="mb-3"><strong>{{
                $translate('customer_group')
            }}</strong></label>
                                            <b-form-select class="form-control" id="input-customer-group" v-model="model.customer_group_id
            " value-field="id" text-field="name" :options="customerGroups">
                                                <template #first>
                                                    <b-form-select-option :value="null">
                                                        {{
            $translate(
                'select_customer_group'
            )
        }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" class="my-3 dd">
                                            <label class="mb-3"><strong>{{
                $translate('customer_agent')
            }}</strong></label>
                                            <b-form-select class="form-control" id="input-customer-agent" v-model="model.customer_agent_id
            " value-field="id" text-field="agent_name" :options="customerAgents">
                                                <template #first>
                                                    <b-form-select-option :value="null">
                                                        {{
            $translate(
                'select_customer_agent'
            )
        }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" class="">
                                            <label class="mb-3"><strong>Attachments</strong></label>
                                            <customer-attachments />
                                        </b-col>
                                    </b-row>

                                    <b-col md="12" cols="12" class="mt-3">
                                        <b-form-row class="mt-6 d-flex align-item-center justify-content-center">
                                            <b-button ref="submit" type="submit" v-show="false">Submit</b-button>
                                            <portal to="customer-view-buttons" :disabled="tabIndex == 0">
                                                <b-button id="customer-location-btn" @click="setLocationListMode" variant="info"
                                                    :disabled="loading" v-if="hasPermissionUpdate &&
            tabIndex == 1 &&
            !isSearchMode &&
            id
            ">{{
            $translate('locations')
        }}</b-button>
                                                <b-button id="customer-create-btn" type="submit" class="me-2" v-if="hasPermissionCreate &&
            !model.id
            " size="fw" variant="info" :disabled="loading ? true : false
            ">{{ createLabel }}</b-button>
                                                <b-button id="customer-update-btn" type="submit" class="me-2" v-if="hasPermissionUpdate &&
            model.id
            " size="fw" variant="info" :disabled="loading ? true : false
            ">{{ updateLabel }}</b-button>
                                                <b-button id="customer-cancel-btn" @click="
            $emit(
                'setNewCustomerForm'
            )
            " class="btn-fw me-2" variant="info" v-show="tabIndex == 0">
                                                    {{ $cancelLabel() }}
                                                </b-button>
                                                <b-button id="customer-delete-btn" v-if="!isNew &&
            hasPermissionDelete &&
            tabIndex == 0
            " @click="deleteCustomer()" variant="delete-button">
                                                    {{ $deleteLabel() }}
                                                </b-button>
                                                <b-button variant="info" v-if="!isNew && tabIndex == 0
            " @click="
            $router.push(
                ordersRoute
            )
            ">
                                                    {{
            $translate(
                'view_activities'
            )
        }}
                                                </b-button>
                                            </portal>
                                        </b-form-row>
                                    </b-col>
                                </b-form>
                            </b-card-body>
                        </b-tab>
                        <b-tab :title="$translate('location')" class="p-0">
                            <b-card-body class="p-0 py-3">
                                <location-section ref="locationSectionRef" v-model="model.location_section_id"
                                    :hide-controls="true" :customer_id="parseInt(id, 10) ?? -1" @set-location-section="evt => {
            setLocationData(evt, 'model')
        }
            " @searchMode="evt => (isSearchMode = evt)">
                                </location-section>
                            </b-card-body>
                            <b-card-footer>
                                <div class="d-flex gap-2 justify-content-center">
                                    <b-button id="set-location-list-mode-btn" @click="setLocationListMode()" variant="info" :disabled="loading" v-if="hasPermissionUpdate &&
            tabIndex == 1 &&
            !isSearchMode &&
            id
            ">{{ $translate('locations') }}</b-button>
                                    <!--  <b-button
                    type="submit"
                    @click="saveLocation()"
                    class="me-2"
                    v-if="hasPermissionCreate && !model.id"
                    size="fw"
                    variant="info"
                    :disabled="loading ? true : false"
                    >{{ createLabel }}</b-button
                  >
                  <b-button
                    type="submit"
                    @click="saveLocation()"
                    class="me-2"
                    v-if="hasPermissionUpdate && model.id"
                    size="fw"
                    variant="info"
                    :disabled="loading ? true : false"
                    >{{ updateLabel }}</b-button
                  > -->

                                    <!--  <b-button
                        @click="$emit('exit-customer-view')"
                        variant="info"
                      >
                        {{ $translate("ok") }}
                      </b-button> -->

                                    <b-button id="cancel-customer-btn" @click="cancelCustomer()" variant="info" v-show="tabIndex == 0">
                                        {{ $translate('cancel') }}
                                    </b-button>
                                    <b-button id="delete-customer-btn" v-if="!isNew &&
            hasPermissionDelete &&
            tabIndex == 0
            " @click="deleteCustomer()" variant="outline-danger">
                                        {{ $translate('delete') }}
                                    </b-button>
                                    <b-button id="view-customer-activity-btn" variant="info" v-if="!isNew && tabIndex == 0"
                                        @click="$router.push(ordersRoute)">
                                        {{ $translate('view_activities') }}
                                    </b-button>
                                </div>
                            </b-card-footer>
                        </b-tab>
                        <b-tab :title="$translate('contact')" class="p-0">
                            <b-card-body class="p-0 py-3">
                                <customer-users :allow-deletion="true"></customer-users>
                            </b-card-body>
                        </b-tab>
                        <b-tab :title="$translate('ratings')" class="p-0" v-if="!isNew">
                            <rating-list-items :customer_id="id" ref="table" @report-state="loading = $event"
                                :items="orders">
                            </rating-list-items>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </template>
        </b-modal>

        <b-card v-if="isRouteCustomer">
            <b-overlay :show="!loaded || generalDeleting" rounded="sm">
                <div class="d-flex title-bar-block">
                    <div class="icon-block me-3">
                        <button id="cancel-customer-data-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancelCustomer">
                            <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="text">
                        <span class="me-2">{{ title }}</span>
                    </div>
                </div>
                <b-form class="form-sample">
                    <b-tabs card v-model="tabIndex" align="center" class="mt-3 customer-tabs">
                        <b-tab :title="$translate('general')" class="p-0">
                            <b-card-body class="mt-3 p-0">
                                <b-form @submit.stop.prevent="saveCustomer()">
                                    <b-row>
                                        <b-col md="6" cols="12">
                                            <label class="mb-3"><strong>{{
            $translate('code')
        }}</strong>
                                            </label>
                                            <b-input id="code" name="code" v-model="model.code" type="text"></b-input>
                                        </b-col>
                                        <b-col md="6" cols="12" class="mt-3 mt-md-0">
                                            <label class="mb-3"><strong>{{ $translate('name')
                                                    }}<span class="red">*</span></strong></label>
                                            <b-input id="input-name" v-model="model.name" v-custom-validation="$textRequired()
            " required :error="errors.first('name')" type="text"></b-input>
                                        </b-col>
                                        <!-- </b-row>
                                    <b-row> -->
                                        <b-col md="6" cols="12" class="mt-3">
                                            <label class="mb-3"><strong>{{
            $translate('email_address')
        }}</strong></label>
                                            <b-input name="email" id="input-email" v-model="model.email" type="email"></b-input>
                                        </b-col>
                                        <b-col md="6" cols="12" class="mt-3">
                                            <label class="mb-3"><strong>{{
            $translate('telephone')
        }}</strong></label>
                                            <b-input id="phone" name="phone" v-model="model.phone" type="tel"></b-input>
                                        </b-col>
                                        <b-col md="6" cols="12" class="mt-3">
                                            <label class="mb-3"><strong>{{
            $translate('work_number')
        }}</strong></label>
                                            <b-input id="work_number" name="work_number"
                                                v-model="model.work_number"></b-input>
                                        </b-col>
                                        <!-- </b-row>
                                    <b-row> -->
                                        <b-col md="6" cols="12" class="mt-3" v-if="checkCustomerAdditionaField1">
                                            <label class="mb-3"><strong>{{
            customer_additional_field_1.label
        }}</strong></label>
                                            <b-input id="customer-additional-field-1" name="customer-additional-field-1"
                                                v-model="model.additional_field_1
            " type="text"></b-input>
                                        </b-col>
                                        <b-col md="6" cols="12" class="mt-3" v-if="checkCustomerAdditionaField2">
                                            <label class="mb-3"><strong>{{
            customer_additional_field_2.label
        }}</strong></label>
                                            <b-input id="customer-additional-field-2" name="customer-additional-field-2"
                                                v-model="model.additional_field_2
            " type="text"></b-input>
                                        </b-col>
                                        <!-- </b-row>
                                    <b-row> -->
                                        <b-col md="6" cols="12" class="mt-3 dd">
                                            <label class="mb-3"><strong>{{
            $translate(
                'customer_segment'
            )
        }}</strong></label>
                                            <b-form-select id="input-customer-segment" class="form-control" v-model="model.customer_segment_id
            " value-field="id" text-field="name" :options="customerSegments">
                                                <template #first>
                                                    <b-form-select-option :value="null">
                                                        {{
            $translate(
                'select_customer_segment'
            )
        }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                        <b-col md="6" cols="12" class="mt-3 dd">
                                            <label class="mb-3"><strong>{{
                $translate('customer_group')
            }}</strong></label>
                                            <b-form-select id="input-customer-group" class="form-control" v-model="model.customer_group_id
            " value-field="id" text-field="name" :options="customerGroups">
                                                <template #first>
                                                    <b-form-select-option :value="null">
                                                        {{
            $translate(
                'select_customer_group'
            )
        }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                        <!-- </b-row>
                                    <b-row> -->
                                        <b-col md="6" cols="12" class="my-3 dd">
                                            <label class="mb-3"><strong>{{
                $translate('customer_agent')
                                                    }}</strong></label>
                                            <b-form-select id="input-customer-agent" class="form-control" v-model="model.customer_agent_id
            " value-field="id" text-field="agent_name" :options="customerAgents">
                                                <template #first>
                                                    <b-form-select-option :value="null">
                                                        {{
                                                        $translate(
                                                        'select_customer_agent'
                                                        )
                                                        }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                        <b-col md="6" cols="12" class="my-3 dd">
                                            <label class="mb-3"><strong>{{
                                                    $translate(
                                                    'lifecycle_stage'
                                                    )
                                                    }}</strong></label>
                                            <b-form-select id="input-lifecycle-stage" class="form-control" v-model="model.lifecycle_stage_id
            " value-field="id" text-field="name" :options="lifecycleStages">
                                                <template #first>
                                                    <b-form-select-option :value="null">
                                                        {{
                                                        $translate(
                                                        'select_lifecycle_stage'
                                                        )
                                                        }}
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                        <!-- </b-row>
                                    <b-row> -->
                                        <b-col cols="12" class="">
                                            <label class="mb-3"><strong>{{
                                                    $translate('attachments')
                                                    }}</strong></label>
                                            <customer-attachments />
                                        </b-col>
                                    </b-row>
                                    <b-card-body class="mt-3">
                                        <template v-if="(id > 0 && has_location) ||
            id == 0 ||
            id == null
            ">
                                            <location-section ref="locationSectionRef" :show="!loaded"
                                                :sectionOnly="false" v-model="model.location_section_id
            " :hide-controls="true" @searchMode="evt => (isSearchMode = evt)
            " :customer_id="parseInt(id, 10) ?? -1
            " @set-location-section="(evt) => { setLocationData(evt, 'model') }">
                                            </location-section>
                                        </template>
                                    </b-card-body>
                                    <b-card-footer>
                                        <div class="d-flex gap-2 mb-3 mt-3 justify-content-center">
                                            <b-button id="create-customer-list-btn" @click="saveCustomer()" class="me-2" v-if="hasPermissionCreate &&
            !model.id
            " size="fw" variant="info" :disabled="loading ? true : false
            ">{{ createLabel }}</b-button>
                                            <b-button id="update-customer-list-btn" @click="saveCustomer()" class="me-2" v-if="hasPermissionUpdate &&
            model.id &&
            !isSearchMode
            " size="fw" variant="info" :disabled="loading ? true : false
            ">{{ updateLabel }}</b-button>
                                            <b-button id="cancel-customer-list-btn" @click="cancelCustomer()" variant="info" v-show="tabIndex == 0">
                                                {{ $cancelLabel() }}
                                            </b-button>
                                            <b-button id="location-customer-list-btn" @click="setLocationListMode()" variant="info" size="fw"
                                                :disabled="loading" v-if="hasPermissionUpdate &&
            tabIndex == 0 &&
            !isSearchMode &&
            !isSearchMode &&
            id
            ">{{
                                                $translate('locations')
                                                }}</b-button>
                                            <b-button id="delete-customer-list-btn" v-if="!isNew &&
            hasPermissionDelete &&
            tabIndex == 0
            " @click="deleteCustomer()" variant="delete-button">
                                                {{ $deleteLabel() }}
                                            </b-button>
                                            <b-button id="customer-activity-list-btn" variant="info" v-if="!isNew && tabIndex == 0" @click="
            $router.push(ordersRoute)
            ">
                                                {{
                                                $translate(
                                                'View Activities'
                                                )
                                                }}
                                            </b-button>
                                        </div>
                                    </b-card-footer>
                                </b-form>
                            </b-card-body>
                        </b-tab>
                        <b-tab :title="$translate('contact')" class="mt-3">
                            <b-card-body>
                                <customer-users :allow-deletion="true"></customer-users>
                            </b-card-body>
                        </b-tab>
                        <b-tab :title="$translate('ratings')" v-if="!isNew" class="mt-3">
                            <rating-list-items :customer_id="id" ref="table" @report-state="loading = $event"
                                :items="orders">
                            </rating-list-items>
                        </b-tab>
                    </b-tabs>
                </b-form>
            </b-overlay>
        </b-card>
    </div>
</template>
<script>
//const _ = require('lodash')
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import CustomerAttachments from './CustomerAttachments.vue'
import LocationSection from '@/views/Location/LocationSection'
import CustomerUsers from '@/components/CustomerUsers.vue'
import RatingListItems from './RatingListItems.vue'
import permissionsMixins from '@/mixins/permissionsMixins'
import locationMixins from '@/mixins/locationMixins'

export default {
    name: 'customers-view',
    components: {
        CustomerUsers,
        LocationSection,
        RatingListItems,
        CustomerAttachments,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins, locationMixins],
    data() {
        return {
            model: {
                id: 0,
                code: '',
                name: '',
                reference_no: '',
                email: '',
                phone: '',
                work_number: '',
                additional_field_1: '',
                additional_field_2: '',
                customer_segment_id: null,
                lifecycle_stage_id: null,
                customer_group_id: null,
                customer_agent_id: null,
                location_section_id: null,
                location: null,
                section_name: null,
            },
            isSearchMode: false,
            loaded: false,
            tabIndex: 0,
            loading: false,
            count: 0,
            has_location: false,
        }
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
        hideButtons: { type: Boolean, default: false },
        isCustomerVisible: { type: Boolean },
    },
    computed: {
        componentName() {
            return this.$translate('customer')
        },
        title() {
            return this.isNew
                ? this.$translate('create_customer')
                : this.$translate('update_customer')
        },
        isRouteCustomer() {
            return this.$route.name == 'viewCustomer'
        },
        isNew() {
            if (this.id == 0 || this.id == null) {
                return true
            } else {
                return false
            }
        },
        customerSegments() {
            return this.$store.state.customerSegments.customer_segments
        },
        lifecycleStages() {
            return this.$store.state.lifecycleStage.items
        },
        customerGroups() {
            return this.$store.state.customerGroups.customer_groups
        },
        customerAgents() {
            return this.$store.state.customerAgents.customer_agents
        },
        customer_additional_field_1() {
            const additionalField_2 =
                this.$store.state.additionalField.additional_fields &&
                this.$store.state.additionalField.additional_fields.find(
                    x => x.module_for == 2 && x.field_type === 1
                )
            return additionalField_2
        },
        customer_additional_field_2() {
            const additionalField_2 =
                this.$store.state.additionalField.additional_fields &&
                this.$store.state.additionalField.additional_fields.find(
                    x => x.module_for == 2 && x.field_type === 2
                )
            return additionalField_2
        },
        customer() {
            return this.$store.getters['customers/customer']
        },
        cusomerAttachments() {
            return this.$store.state.customerAttachmentsStore.attachments
        },
        customerRoute() {
            return this.$route.name.slice(0, 12) === 'viewCustomer'
        },
        orders() {
            return this.$store.state.orders.items
        },
        ordersRoute() {
            return `/ams/activities?page=1&query=&customer_id=${this.model.id}&entity=1`
        },
        isParentView() {
            return this.$route.name != 'viewCustomer'
        },
        checkCustomerAdditionaField1() {
            return (
                this.customer_additional_field_1 &&
                this.customer_additional_field_1.label
            )
        },
        checkCustomerAdditionaField2() {
            return (
                this.customer_additional_field_2 &&
                this.customer_additional_field_2.label
            )
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },

        compositeCustomerFields() {
            const {
                tabIndex,
                model: { code, name, email, phone },
            } = this
            return JSON.stringify({ code, name, email, phone, tabIndex })
        },

        // submitLabel() {
        //     if (this.loading && this.model.id) {
        //         return 'Updating...'
        //     } else if (this.loading) {
        //         return 'Creating...'
        //     } else if (this.model.id) {
        //         return 'Save'
        //     } else {
        //         return 'Create'
        //     }
        // },
    },

    created() { },
    watch: {
        isSearchMode: function (val) {
            console.log('isSearchMode:', val)
        },
        customer: {
            immediate: true,
            handler: function (model) {
                this.model = {
                    ...model,
                }
                if (model) this.loaded = true
                console.log('model after', this.model)
            },
            deep: true,
        },

        lifecycleStages: {
            handler: function (items) {
                this.setKeyDefault(items, 'lifecycle_stage_id')
            },
            deep: true,
        },
        customerSegments: {
            handler: function (items) {
                this.setKeyDefault(items, 'customer_segment_id')
            },
            deep: true,
        },
        customerGroups: {
            handler: function (items) {
                this.setKeyDefault(items, 'customer_group_id')
            },
            deep: true,
        },

        compositeCustomerFields: {
            handler: function () {
                const { model } = this
                console.log('customerModels', model)
                this.$emit('update-model', model)
            },
        },
    },
    mounted() {
        const { id } = this
        if (this.id == 0 || this.id == null) {
            this.loaded = true
        } else {
            this.loaded = false
        }
        if (id > 0) {
            this.$store.dispatch('customers/fetchById', id)
            this.$store.dispatch('customerSegments/fetchAll')
            this.$store.dispatch('lifecycleStage/fetchAll')
            this.$store.dispatch('customerGroups/fetchAll')
            this.$store.dispatch('customerAgents/fetchAll')
            this.$store.dispatch('additionalField/fetchAll', { module_for: 2 })
            this.has_location = true
        }
        if (this.id == 0 || this.id == null) {
            this.$store.dispatch('customerSegments/fetchAll')
            this.$store.dispatch('customerGroups/fetchAll')
            this.$store.dispatch('customerAgents/fetchAll')
            this.$store.dispatch('lifecycleStage/fetchAll')
            this.$store.dispatch('additionalField/fetchAll', { module_for: 2 })
            this.loaded = true
        } else {
            this.loaded = false
        }
    },
    methods: {
        setLocationListMode() {
            return this.$refs['locationSectionRef']?.setSearchMode()
        },

        setKeyDefault(items, key) {
            if (items.length > 0) {
                const defaultType = items.find(x => !!x.is_default)
                if (defaultType) {
                    this.$set(this.model, key, defaultType.id)
                }
            }
        },
        // searchMode(val) {
        //     this.isSearchMode = val
        // },

        cancelCustomer() {
            this.$router.push({ name: 'customers' })
        },
        ordersRefRoute(OrderData) {
            this.$router.push(
                `/ams/activities?page=1&query=${OrderData.reference_no}&customer_id=${this.model.id}&entity=1`
            )
        },
        async saveCustomer() {
            try {
                this.loading = true
                this.loaded = false

                const { model, cusomerAttachments: attachments } = this
                const customerModel = { ...model, attachments }
                /////check location error
                this.checkLocationError(model, model.location_section_id);

                const data = await this.$store.dispatch(
                    `customers/${model.id ? 'update' : 'create'}`,
                    customerModel
                )
                if (this.isNew && this.isCustomerVisible) {
                    // this.$emit('setNewCustomerForm')
                    this.genericToast(
                        this.componentName,
                        this.$translate('created'),
                        'success',
                        `${this.componentName} ${this.$translate(
                            'create_alert'
                        )}`
                    )
                } else if (this.isNew) {
                    // const path = '/ams/customers'
                    this.has_location = true
                    this.tabIndex = 1
                    this.$router.push(`/ams/customers/${data.id}`)
                    this.$nextTick(() => {
                        this.genericToast(
                            this.componentName,
                            this.$translate('created'),
                            'success',
                            `${this.componentName} ${this.$translate(
                                'create_alert'
                            )}`
                        )
                    })
                } else {
                    this.has_location = true
                    this.$router.push(`/ams/customers/${this.model.id}`)
                    // const path = '/ams/customers'
                    // this.$router.push({ path })
                    this.$nextTick(() => {
                        this.genericToast(
                            this.componentName,
                            this.$translate('updated'),
                            'success',
                            `${this.componentName} ${this.$translate(
                                'update_alert'
                            )}`
                        )
                    })
                }
                this.$emit('setNewCustomerForm')
            } catch (error) {
                this.doToast(
                    this.$translate('error'),
                    error.message || error.response.data.error.message,
                    'danger'
                )
            } finally {
                this.loading = false
                this.loaded = true
            }
        },
        // async saveLocation() {
        //     const { model, cusomerAttachments: attachments, } = this
        //     const customerModel = { ...model, attachments }
        //     try {
        //         this.loading = true
        //         let { location_section_id, location } = { ...customerModel }
        //         location = location || {}
        //         const { city, address1, address2 } = location

        //         if (!location_section_id && !city && (address1 || address2)) {
        //             throw new Error(
        //                 this.$translate('city_is_required')
        //             )
        //         }
        //         await this.$store.dispatch(
        //             `customers/${model.id ? 'update' : 'create'}`,
        //             customerModel
        //         )
        //         if (this.isNew && this.isCustomerVisible) {
        //             this.genericToast(
        //                 this.componentName,
        //                 this.$translate('created'),
        //                 'success',
        //                 `${this.$translate('location')} ${this.$translate('create_alert')}`,
        //             )
        //         }
        //         else if (this.isNew) {
        //             const path = '/ams/customers'
        //             this.$router.push({ path })
        //             this.$nextTick(() => {
        //                 this.genericToast(
        //                     this.componentName,
        //                     this.$translate('created'),
        //                     'success',
        //                     `${this.$translate('location')} ${this.$translate('create_alert')}`,
        //                 )
        //             })
        //         } else {
        //             const path = '/ams/customers'
        //             this.$router.push({ path })
        //             this.$nextTick(() => {
        //                 this.genericToast(
        //                     this.componentName,
        //                     this.$translate('updated'),
        //                     'success',
        //                     `${this.$translate('location')} ${this.$translate('update_alert')}`,
        //                 )
        //             })
        //         }
        //         this.$emit('setNewCustomerForm')
        //     } catch (error) {
        //         this.doToast(
        //             this.$translate('error'),
        //             error.message || error.response.data.error.message,
        //             'danger'
        //         )
        //     } finally {
        //         console.log('customer data', model)
        //         this.loading = false
        //     }
        // },

        async deleteCustomer() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/customers',
                deleteRoute: 'customers/delete',
            }
            const notificationFields = {
                type: this.$translate('customer'),
                errorMsg: this.$translate('unable_to_delete_customer'),
            }

            this.deleteItem(notificationFields, model, routes)
        },

        getCustomerModel() {
            const { model, cusomerAttachments: attachments } = this
            return { ...model, attachments }
        },
    },
}
</script>
<style></style>
